import { pathBuilder } from 'config/paths/index';

export const root = '/admin/assets';
export default pathBuilder(root);
